export class SocketChannel {

    channel: string;
    url: string;
    flagCompany: boolean;
    path: string;

    constructor(channel?: string, url?: string, path?: string) {
        this.channel = channel;
        this.url = url;
        this.path = path;
    }

    public get Channel() {
        return this.channel;
    }
    public get Url() {
        return this.url;
    }
    public get FlagCompany() {
        return this.flagCompany;
    }
    public get Path() {
        return this.path;
    }

    public set Channel(channel: string) {
        this.channel = channel;
    }
    public set Url(url: string) {
        this.url = url;
    }
    public set FlagCompany(flagCompany: boolean) {
        this.flagCompany = flagCompany;
    }
    public set Path(path: string) {
        this.path = path;
    }
}
